import { useState, useEffect, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
// services
import * as exhibitorLeadCaptureService from '../../services/exhibitorLeadCaptureService'
import * as webBridgeService from '../../services/webBridgeService'
// ------ Styles ------ //
import styles from './Header.module.css'

const Header = ({ user }) => {
    const [formData, setFormData] = useState(
        {
            leadCapture: {},
            leadCaptureName: null,
            exhibitor: {},
            exhibitorId: null,
        }
    )
    // State    
    const [leadCaptureOptions, setLeadCaptureOptions] = useState([])
    const [leadCaptureInfo, setLeadCaptureInfo] = useState({})
    const [exhibitor, setExhibitor] = useState({})
    const isMounted = useRef(false)

    const fetchLeadCaptures = async () => {
        // use account id to get the LimitedEvents
        // pass LimitedEvents to eventbadges 2.0 to get list of all lead captures for dropdown
        let foundEvents = await webBridgeService.fetchLimitedEvents(user.limitedEvents);
        if (foundEvents && foundEvents.length > 0) {
            setLeadCaptureOptions(foundEvents);
            
        }
        //// verify the login account has access
        //if (formData.clientName && formData.client) {
        //    let req = await createEventsRequestBody();
        //    try {
        //        const leadCaptures = await leadCaptureService.getEventsByClient(formData.client.clientId);
        //        if (leadCaptures && leadCaptures.length > 0) {
        //            setLeadCaptureOptions(leadCaptures);

        //        }
        //        else {
        //            setLeadCaptureOptions([]);
        //        }
        //    } catch /*(err)*/ {
        //        setLeadCaptureOptions([]);
        //    }

        //}

    }
    const createRequestBody = async () => {

        let requestBody =
        {
            "leadCaptureId": `${formData.leadCapture.leadCaptureId}`,
            "limitedExhibitors": `${user.limitedEvents}`,
        }

        return await requestBody;
    }
    const fetchExhibitor = async () => {
        const getReqBody = await createRequestBody()
        // use account id and lead capture id to get exhibitor
        // pass leadcapture id and limited exhibitors to eventbadges 2.0 to get list of all exhibitor for dropdown
        let foundExhibitor = await webBridgeService.fetchLimitedExhibitorLeadCapture(getReqBody);
        if (foundExhibitor && foundExhibitor.length > 0) {
            setExhibitor(foundExhibitor[0])
        }
    }

    useEffect(() => {
        // don't store on initial render
        if (formData.leadCapture && formData.leadCaptureName && isMounted.current) {
            // save to localstorage
            exhibitorLeadCaptureService.setExhibitorLeadCapture({
                leadCaptureId: formData.leadCapture.id,
                leadCaptureName: formData.leadCapture.overwriteName,
            })
            // set the exhibitor
            fetchExhibitor();
        }
        else {
            // pull on initial render
            // meant to prevent blank overwrites
            isMounted.current = true;
        }
    }, [leadCaptureInfo])

    useEffect(() => {
        //set selections to the saved values
        if (leadCaptureOptions && leadCaptureOptions.length > 0 && leadCaptureInfo && leadCaptureInfo.leadCaptureName) {
            setLeadCaptureInfo(leadCaptureInfo.leadCaptureName)
        }
        else if (leadCaptureOptions && leadCaptureOptions.length > 0) {
            // default to first, should be "latest"
            setLeadCaptureInfo(leadCaptureOptions[0].overwriteName);
        }
    }, [leadCaptureOptions])

    useEffect(() => {
        // check if entry is stored
        // store into local object
        let localclientevent = exhibitorLeadCaptureService.getExhibitorLeadCapture()
        if (localclientevent) {
            setLeadCaptureInfo(localclientevent)
        }
        // pull lead capture
        fetchLeadCaptures();
    }, [])

    const clearLeadCapture = () => {
        formData.leadCapture = null;
        formData.leadCaptureName = null;
    }

    const setEventInfo = (leadCaptureName) => {
        let foundLeadCapture = leadCaptureOptions.find((item) => item.overwriteName === leadCaptureName);
        if (foundLeadCapture) {
            formData.leadCapture = foundLeadCapture;
            formData.leadCaptureName = foundLeadCapture.overwriteName;
            //updating React state you must create shallow copies of all state (and nested state) that you are updating.
            setFormData({
                ...formData,
                ['leadCaptureName']: foundLeadCapture.overwriteName,
                ['leadCapture']: foundLeadCapture,
            })
        }
        else {
            formData.leadCaptureName = null;
            formData.leadCapture = {};
            setFormData({
                ...formData,
                ['leadCaptureName']: null,
                ['leadCapture']: {},
            })
        }
    }
    const trimEventName = name => {
        const charCutoff = 75
        const trimmed = name.substring(0, charCutoff) + "..."

        if (name.length <= charCutoff) return name
        return trimmed
    }
    
    const handleChangeLeadCapture = (e) => {

        if (e.target.type === 'select-one') {
            setEventInfo(e.target.value)
            // save to localstorage
            exhibitorLeadCaptureService.setExhibitorLeadCapture({
                leadCaptureId: formData.leadCapture.id,
                leadCaptureName: formData.leadCapture.overwriteName,
            })
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }

    return (
        <div>
            <div className={styles.headerContainer}>

                <div className={styles.middlePane}>
                    Lead Capture:
                    <br />
                    {
                        formData.clientName && formData.client && leadCaptureOptions && leadCaptureOptions.length > 0 ?
                            <select
                                name="leadCaptureName"
                                value={formData.leadCaptureName}
                                onChange={handleChangeLeadCapture}
                                key={formData.leadCaptureName}
                            >
                                <option disabled={true} value="" selected="selected">
                                    -- Select an option --
                                </option>
                                {
                                    leadCaptureOptions.map((ci, idx) => (
                                        <option key={idx}>{trimEventName(ci.overwriteName)}</option>
                                    ))
                                }
                            </select>
                            :
                            <>
                                <div>
                                    <label>No Lead Captures found (
                                        <Link to={`/LeadCaptureList`}>Lead Capture List...)</Link>
                                    </label>
                                </div>
                            </>
                    }
                </div>
                <div className={styles.middlePane}>
                    Exhibitor: 
                    <br />
                    {
                        formData.clientName && formData.client && formData.leadCaptureName && formData.leadCapture && exhibitor && exhibitor.length > 0 ?
                            <>
                                {exhibitor[0].organization} - ({exhibitor[0].email})
                            </>
                            :
                            <>
                                <div>
                                    No Exhibitors found!
                                </div>
                            </>
                    }
                </div>
            </div>

        </div>
    );
}
export default Header;
